module.exports = __webpack_public_path__ + "static/keyboardFocus2-14957bbd8709f0406c8ba61ca7bded8c.gif";